
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { Model, ModelProperty } from 'models/Model';


export class CustomerTenantRequestModel extends Model<CustomerTenantRequestModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'companyId', type: 'guid', languageString: 'customerTenantRequest.property.companyId' },
		{ name: 'id', type: 'number', languageString: 'customerTenantRequest.property.id', isHidden: true },
		{ name: 'name', type: 'string', languageString: 'customerTenantRequest.property.name' },
		{ name: 'domain', type: 'string', languageString: 'customerTenantRequest.property.domain' },
		{ name: 'firstname', type: 'string', languageString: 'customerTenantRequest.property.firstname' },
		{ name: 'lastname', type: 'string', languageString: 'customerTenantRequest.property.lastname' },
		{ name: 'address', type: 'string', languageString: 'customerTenantRequest.property.address' },
		{ name: 'city', type: 'string', languageString: 'customerTenantRequest.property.city' },
		{ name: 'postalCode', type: 'string', languageString: 'customerTenantRequest.property.postalCode' },
		{ name: 'countryCode', type: 'string', languageString: 'customerTenantRequest.property.countryCode' },
		{ name: 'contactFirstname', type: 'string', languageString: 'customerTenantRequest.property.contactFirstname' },
		{ name: 'contactLastname', type: 'string', languageString: 'customerTenantRequest.property.contactLastname' },
		{ name: 'contactPhoneNumber', type: 'string', languageString: 'customerTenantRequest.property.contactPhoneNumber' },
		{ name: 'contactEmail', type: 'string', languageString: 'customerTenantRequest.property.contactEmail' }
	];
	[key: string]: any;
	
	public companyId?: string;
	public id: number;
	public name: string;
	public domain: string;
	public firstname: string;
	public lastname: string;
	public address: string;
	public city: string;
	public postalCode: string;
	public countryCode: string;
	public contactFirstname: string;
	public contactLastname: string;
	public contactPhoneNumber: string;
	public contactEmail: string;
    
	constructor(){
		super();
		this.companyId = undefined;
		this.id = 0;
		this.name = '';
		this.domain = '';
		this.firstname = '';
		this.lastname = '';
		this.address = '';
		this.city = '';
		this.postalCode = '';
		this.countryCode = '';
		this.contactFirstname = '';
		this.contactLastname = '';
		this.contactPhoneNumber = '';
		this.contactEmail = '';
		
	}
	getProperties(){
		return CustomerTenantRequestModel.classProperties;
	}
}

